import { render, staticRenderFns } from "./login-number-related.vue?vue&type=template&id=635c3f29&"
import script from "./login-number-related.vue?vue&type=script&lang=js&"
export * from "./login-number-related.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports